import { CategoryTabIds } from '@shared/constants';

export const ANIMATION_WAIT = 500;

export const SCROLL_TRACK_TOP_OFFSET = 200;

export const TAG_NAME_TRACK_MAPPING_LEGACY = {
    gender_132: 'women',
    gender_134: 'men',
    gender_136: 'kids',
    58: 'home',
};

export enum CampaignFilterTags {
    ALL = 'ALL',
    STARTING_TODAY = 'STARTING_TODAY',
    ENDING_TODAY = 'ENDING_TODAY',
}

export const CATEGORY_TAB_ID_TRACK_MAPPING = {
    [CategoryTabIds.ALL]: 'all',
    [CategoryTabIds.WOMEN]: 'women',
    [CategoryTabIds.MEN]: 'men',
    [CategoryTabIds.KIDS]: 'kids',
    [CategoryTabIds.HOME]: 'home',
};
